import { ONBOARDING_MY_LABEL } from 'module/onboarding/utils/onboardingPermission';
import type { AccessType, ModulePermission } from './SecurityRoleMatrix.types';

/** Permissions that must stay enabled and cannot be unchecked in the role matrix. */
const LOCKED_TRUE_PERMISSIONS: Record<string, AccessType[]> = {
	[ONBOARDING_MY_LABEL]: ['view', 'edit'],
};

/** Permissions with no effect for a label; hidden from toggling in the role matrix. */
const DISABLED_PERMISSIONS: Record<string, AccessType[]> = {
	[ONBOARDING_MY_LABEL]: ['delete', 'execute'],
};

export const applyLockedPermissions = (permissions: ModulePermission[]): ModulePermission[] =>
	permissions.map((module) => ({
		...module,
		functions: module.functions.map((func) => {
			const lockedTrue = LOCKED_TRUE_PERMISSIONS[func.name];
			const disabled = DISABLED_PERMISSIONS[func.name];
			if (!lockedTrue && !disabled) return func;

			const updatedPermissions = { ...func.permissions };

			lockedTrue?.forEach((access) => {
				updatedPermissions[access] = true;
			});

			disabled?.forEach((access) => {
				updatedPermissions[access] = false;
			});

			return { ...func, permissions: updatedPermissions };
		}),
	}));

export const isPermissionCheckboxDisabled = (
	funcName: string,
	access: AccessType,
	readonly?: boolean,
): boolean => {
	if (readonly) return true;

	const lockedTrue = LOCKED_TRUE_PERMISSIONS[funcName];
	if (lockedTrue?.includes(access)) return true;

	const disabled = DISABLED_PERMISSIONS[funcName];
	return disabled?.includes(access) ?? false;
};
